import React, { useContext } from "react";
import { Link } from "react-router-dom";
import PromotionalProductCatEditIcon from "../../pages/promotion-product-cat/PromotionalProductCatEditIcon"
import { replaceOrigin } from "../../util/helper";
import { getURLHelper } from "../../helpers/url";

const PromotionalProductSingleCategory = ({ data, categoriesPerRow }) => {

    let proCatId = data._id;
    let title = data.title ? data.title : "";
    let description = data.description ? data.description : "";
    let btnText = data.btnText ? data.btnText : "";
    let link = data.btnUrl ? data.btnUrl : "/";
    let btnStyle = {
        color: data.btnTextColor,
        backgroundColor: data.btnBgColor,
    }
    let imageStyle = {
        height: data.imageHeight ? data.imageHeight + 'px' : 'auto'
    }
    let btnBgHoverColor = data.btnBgHoverColor ? data.btnBgHoverColor : ""
    let btnTextHoverColor = data.btnTextHoverColor ? data.btnTextHoverColor : ""
    let btnBgColor = data.btnBgColor ? data.btnBgColor : ""
    let btnTextColor = data.btnTextColor ? data.btnTextColor : ""
    let bgImg = data.productImage ? data.productImage : "";
    const diagGrayBackground = data.diagGrayBackground;

    return (
        <>
            <div className={`antera-featured-promo-cat-container ${categoriesPerRow === 3 ? "col-sm-4" :"col-sm-6"} col-12 my-3`}>
                <div className="featured-product">
                    <div className="edit-inline">
                        <PromotionalProductCatEditIcon proCatId={proCatId} fromEditAction="bgImg" />
                        <img 
                            src={replaceOrigin(bgImg)}
                            className="antera-featured-promo-cat-image img-fluid"
                            alt=""
                            style={imageStyle}
                        />
                    </div>

                    <div className={`${diagGrayBackground ? "shape-separate" : ""}`}/>
                    <div className="product-name d-flex justify-content-center align-items-center text-center">

                        <div className="product-details">
                                <div className="edit-title-inline">
                                    <PromotionalProductCatEditIcon proCatId={proCatId} fromEditAction="title" />
                                </div>
                            <h3 dangerouslySetInnerHTML={{ __html: data.title }}>
                                
                                
                            </h3>
                                <div className="edit-inline">
                                    <PromotionalProductCatEditIcon proCatId={proCatId} fromEditAction="description" />
                                </div>
                            <p dangerouslySetInnerHTML={{ __html: data.description }}>
                                
                            </p>
                            <div className="edit-inline">
                                <PromotionalProductCatEditIcon proCatId={proCatId} fromEditAction="btn" />
                            </div>
                            {btnText && (<a style={btnStyle} className="antera-featured-promo-cat-button shop-btn" href={getURLHelper(link)}
                                onMouseOver={(e) => {
                                    e.target.style.backgroundColor = btnBgHoverColor
                                    e.target.style.color = btnTextHoverColor
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.backgroundColor = btnBgColor
                                    e.target.style.color = btnTextColor
                                }}
                            >
                                {btnText}
                            </a>)}

                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default PromotionalProductSingleCategory;
